@if (header) {
<div class="mwp-table-header w-100 d-flex justify-content-center align-items-center">
  @if (translateHeader) {
  <div class="d-inline-flex w-100 p-3">
    <mwp-text-translate [text]="header" [jsonKey]="header" />
    {{nameInHeader}}
  </div>
  }
  @if (!translateHeader) {
  <div class="d-inline-flex w-100 p-3">
    {{header}}{{nameInHeader}}
  </div>
  }
</div>
}

@if(subheader){
  <div class="mwp-table-subheader w-100 px-3 pb-3">{{subheader}}</div>
}
<div class="mwp-table-body" [ngClass]="[header ? 'header px-3' : 'no-header', isModal ? 'is-modal' : 'pb-3']">
  @if (isLoaded) {
  <table mat-table [dataSource]="dataSource">
    @for (tableColumn of tableColumns; track $index) {
    <ng-container matColumnDef="{{tableColumn.propertyId}}">
      <thead>
        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'width' : (tableColumn.width) ? (tableColumn.width) : 'auto'}">
          @if (tableColumn.columnType === columnType.checkBoxSelectAll) {
          <div>
            <mat-checkbox [checked]="isSelectAll" [disabled]="(!dataSource || dataSource.data.length === 0)" (change)="selectAll($event, tableColumn)" />
          </div>
          }
          @if (tableColumn.columnType != columnType.checkBoxSelectAll && tableColumn.columnName !='' ) {
          <div [class]="tableColumn.cssCustomHeaderClass">
            <mwp-text-translate [text]="tableColumn.columnName" [jsonKey]="tableColumn.columnName" />
          </div>
          }
        </th>
      </thead>
      <tbody>
        <td mat-cell *matCellDef="let element; let rowIndex = index">
          @if (displayElement(tableColumn, columnType.checkBoxSelectAll, element)) {
          <div>
            <mat-checkbox [checked]="element[tableColumn.propertyId]" (change)="selectAllChange($event, tableColumn)">
              @if (tableColumn.dataTypeText) {
              <span>{{ findElementByColumnName(element, tableColumn.dataTypeText, tableColumn.textType) }}</span>
              }
            </mat-checkbox>
          </div>
          }
          @if (displayElement(tableColumn, columnType.checkBox, element)) {
          <div>
            <mat-checkbox [checked]="element[tableColumn.propertyId]">
              @if (tableColumn.dataTypeText) {
              <span>{{ findElementByColumnName(element, tableColumn.dataTypeText, tableColumn.textType) }}</span>
              }
            </mat-checkbox>
          </div>
          }
          @if (displayElement(tableColumn, columnType.hyperLink, element)) {
          <div class="d-inline-flex">
            @if(findElementByColumnName(element, tableColumn.dataTypePropertyId, tableColumn.textType) != ""){
            <a (click)="openLink(element[tableColumn.propertyId], tableColumn.isNewTab, tableColumn.isEmit, element)" class="d-inline-flex text-break">
              @if (tableColumn.svgPropertyId || tableColumn.svgCustomName) {
                <mwp-svg-icon [SvgMatType]="findSVGType(element, tableColumn)"/>
              }
              <span>{{ findElementByColumnName(element, tableColumn.dataTypePropertyId, tableColumn.textType) }}</span>
            </a>
            }
          </div>
          }
          @if (displayElement(tableColumn, columnType.button, element)) {
          <div>
            <button (click)="selection(element, tableColumn)" [ngClass]="tableColumn.cssCustomClass ? tableColumn.cssCustomClass : 'mwp-button'" [disabled]='!findElementBoolean(element, tableColumn.isBooleanPropertyId)'>
              <mwp-text-translate [text]="tableColumn.dataTypeText" [jsonKey]="tableColumn.dataTypeText" />
            </button>
          </div>
          }
          @if (displayElement(tableColumn, columnType.slideToggle, element)) {
          <div>
            <mat-slide-toggle [class]="element[tableColumn.dataTypeText]" [(ngModel)]="element[tableColumn.propertyId]">
              <span>{{ findElementByColumnName(element, tableColumn.dataTypeText, tableColumn.textType) }}</span>
            </mat-slide-toggle>
          </div>
          }
          @if (displayElement(tableColumn, columnType.buttonToggle, element)) {
          <div>
            <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [(ngModel)]="element[tableColumn.propertyId]">
              @for (item of tableColumn.listArray; track item) {
              <mat-button-toggle [value]="item.value">
                {{item.text}}
              </mat-button-toggle>
              }
            </mat-button-toggle-group>
          </div>
          }
          @if (displayElement(tableColumn, columnType.input, element)) {
          <div class="pe-4">
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="element[tableColumn.propertyId]">
            </mat-form-field>
          </div>
          }
          @if (displayElement(tableColumn, columnType.labelAndToolTip, element)) {
          <div>
            <div class="d-inline-flex align-items-center">
              @if (element[tableColumn.toolTip] && !tableColumn.toolTipDisplayEnd) {
              <div class="me-2">
                <mwp-svg-icon [SvgMatType]="findSVGType(element, tableColumn)" [SvgColor]="findSVGColor(tableColumn.toolTipCSS)" [ToolTipMessage]="element[tableColumn.toolTip]" [ToolTipClass]="tableColumn.toolTipCSS" />
              </div>
              }
              <div>
                <span>{{ findElementByColumnName(element, tableColumn.propertyId, tableColumn.textType) }}</span>
              </div>
              @if (element[tableColumn.toolTip] && tableColumn.toolTipDisplayEnd) {
              <div class="ms-2">
                <mwp-svg-icon [SvgMatType]="findSVGType(element, tableColumn)" [SvgColor]="findSVGColor(tableColumn.toolTipCSS)" [ToolTipMessage]="element[tableColumn.toolTip]" [ToolTipClass]="tableColumn.toolTipCSS" />
              </div>
              }
            </div>
          </div>
          }
          @if (displayElement(tableColumn, columnType.label, element)) {
          <div [class]="tableColumn.cssCustomClass">
            <span>{{ findElementByColumnName(element, tableColumn.propertyId, tableColumn.textType) }}</span>
          </div>
          }
          @if (displayElement(tableColumn, columnType.iconButton, element)) {
          <div class="selectable" [class]="tableColumn.cssCustomClass">
            @if (displayIconButton(element, tableColumn)) {
              <mwp-svg-icon [SvgMatType]="findSVGTypeByCustomName(tableColumn.svgCustomName)" (click)="selection(element, tableColumn)"/>
            }
          </div>
          }
        </td>
      </tbody>
    </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="renderdColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: renderdColumns; let index= index"></tr>
  </table>
  }
  @if (!dataSource || dataSource.data.length === 0) {
  <div class="d-flex justify-content-center w-100 table-no-data">
    <span>
      <mwp-text-translate text="No Data Found!" jsonKey="noDataFound" />
    </span>
  </div>
  }
</div>